import { render, staticRenderFns } from "./PublicApiTokenForm.vue?vue&type=template&id=af286404"
import script from "./PublicApiTokenForm.vue?vue&type=script&lang=js"
export * from "./PublicApiTokenForm.vue?vue&type=script&lang=js"
import style0 from "./PublicApiTokenForm.vue?vue&type=style&index=0&id=af286404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports